import { VendorForgotPasswordPage } from "@/features/vendor-app/pages/VendorForgotPasswordPage";
import { createFileRoute } from "@tanstack/react-router";

// Single vendor domain — forgot-password lives at the root path (no /vendor
// prefix needed).
export const Route = createFileRoute("/forgot-password")({
  component: VendorForgotPasswordPage,
});
